/**
 * UI-6b Task 8 — AgentUtilization widget manifest.
 */
import { registerWidget } from '../registry.js'
import type { WidgetManifest } from '../types.js'
import { AgentUtilizationRenderer, type AgentUtilizationConfig } from './Renderer.js'
import { AgentUtilizationConfigEditor } from './ConfigEditor.js'

export const agentUtilizationManifest: WidgetManifest<AgentUtilizationConfig> = {
  type: 'agent-utilization',
  label: 'Agent Utilization',
  description: 'Talk-time as % of period per agent (last 24h).',
  defaultSize: '2x1',
  defaultConfig: { agentIds: [] },
  Renderer: AgentUtilizationRenderer,
  ConfigEditor: AgentUtilizationConfigEditor,
}

registerWidget(agentUtilizationManifest)
